import { z } from 'zod/v4';

// A favorite is identified by the cross-owner global vendor id — the same id the
// scoreboard groups rows by — so favoriting a contractor applies across every
// owner that contractor has bid with.
export const vendorFavoriteParamSchema = z.object({
  globalVendorId: z.uuid(),
});

export const insertVendorFavoriteSchema = z.object({
  globalVendorId: z.uuid(),
});

export type InsertVendorFavorite = z.infer<typeof insertVendorFavoriteSchema>;
